webpackJsonp([402],{

/***/ 1768:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(953),
  /* template */
  __webpack_require__(2176),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/showcase-59.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] showcase-59.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4034ddec", Component.options)
  } else {
    hotAPI.reload("data-v-4034ddec", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2176:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("使用案例")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("如果你的产品在使用"), _c('code', [_vm._v("VUX")]), _vm._v(", 请直接发 PR 修改 "), _c('code', [_vm._v("docs/zh-CN/about/showcase.md")]), _vm._v("（置于列表最后，统一格式：二维码必须无白边框）。")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwihri9hzj2066066dgb.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwii8udl7j2088088jrj.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwiiq61ihj207v07vjr8.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwij2qezej2066066dfy.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwijfw73zj20aa0aaaa9.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwijtrvp1j20do0do4gp.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwike27c8j207c07cdg4.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwikqk1xwj2088088myl.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwil30l2oj20b40b4wf0.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwilfmz9xj20aa0aaacp.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwilte2naj20aa0aajru.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwim77oc5j2064066gnh.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpwimm8dtkj208508cqjf.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://ws1.sinaimg.cn/large/663d3650gy1fpmuvjf5x6j208c08c74f.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://common-1251785959.cosbj.myqcloud.com/mdachu.jpg",
      "width": "150"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://img.yw0511.com/others/1528080310.png",
      "width": "150",
      "alt": "原味生活"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://images.wumakeji.com/niuxiaoyun/1528080310.jpg",
      "width": "150",
      "alt": "牛小云"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4034ddec", module.exports)
  }
}

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1768);

/***/ }),

/***/ 953:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX 使用案例 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 402.8b976649.js